import React, { Component } from "react";
import { Link } from "react-router-dom";

class HeaderMenuPrimary extends Component {
  constructor(props) {
    super();
    this.state = {
      over: false,
    };
  }

  handleOver = () => {
    this.setState({ over: !this.state.over });
  };

  render() {
    return (
      <nav className="menu-primary">
        <ul className="nav">
          <li className="nav-item">
            <Link to={process.env.PUBLIC_URL + "/"} title="Home">
              Home
            </Link>
          </li>

          <li
            className={
              "nav-item " +
              (window.location.pathname.includes("/services") ||
              window.location.pathname.includes("/service-inside")
                ? "current-nav-item"
                : "")
            }
          >
            <Link to={process.env.PUBLIC_URL + "/services"} title="Services">
              Services
            </Link>
          </li>

          <li
            className={
              "nav-item " +
              (window.location.pathname.includes("/about-us")
                ? "current-nav-item"
                : "")
            }
          >
            <Link to={process.env.PUBLIC_URL + "/about-us"} title="About us">
              About us
            </Link>
          </li>

          <li
            className={
              "nav-item " +
              (window.location.pathname.includes("/why-us")
                ? "current-nav-item"
                : "")
            }
          >
            <Link to={process.env.PUBLIC_URL + "/why-us"} title="Why us">
              Why us
            </Link>
          </li>

          <li
            className={
              "nav-item " +
              (window.location.pathname.includes("/reviews")
                ? "current-nav-item"
                : "")
            }
          >
            <Link to={process.env.PUBLIC_URL + "/reviews"} title="Reviews">
              Reviews
            </Link>
          </li>

          <li
            className={
              "nav-item " +
              (window.location.pathname.includes("/clients")
                ? "current-nav-item"
                : "")
            }
          >
            <Link to={process.env.PUBLIC_URL + "/clients"} title="Clients">
              Clients
            </Link>
          </li>

          <li
            className={
              "nav-item " +
              (window.location.pathname.includes("/news") ||
              window.location.pathname.includes("/news-single-page")
                ? "current-nav-item"
                : "")
            }
          >
            <Link to={process.env.PUBLIC_URL + "/news"} title="News">
              News
            </Link>
          </li>

          <li
            className={
              "nav-item " +
              (window.location.pathname.includes("/contacts")
                ? "current-nav-item"
                : "")
            }
          >
            <Link to={process.env.PUBLIC_URL + "/contacts"} title="Contacts">
              Contacts
            </Link>
          </li>
        </ul>
      </nav>
    );
  }
}

export default HeaderMenuPrimary;
